import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { CustomerDetailPage, customerName, customerQueryOptions } from '@/features/customers';

export const Route = createFileRoute('/_authed/_active/s/$storeId/customers/$customerId')({
  staticData: { tours: ['customers.detail'] },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'customers.read');
  },
  loader: async ({ context, params }) => {
    const customer = await context.queryClient.query({
      ...customerQueryOptions(params.storeId, params.customerId),
      staleTime: 'static',
    });
    return { crumb: customerName(customer) ?? customer.email };
  },
  component: CustomerDetailPage,
});
